import Vue from 'vue'
import Router from 'vue-router'
import {isAuthenticated} from '@/services/auth'
import VueSession from 'vue-session'

// Views
import Home from '@/views/Home'
import Detail from '@/views/Detail'
import Marketplace from '@/views/Marketplace'
import Access from '@/views/Access'
import Blog from '@/views/Blog'
import BlogDetail from '@/views/BlogDetail'
import About from '@/views/About'
import Profile from '@/views/Profile'
import Contact from '@/views/Contact'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Access',
      component: Access
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/property-detail/:slug',
      name: 'Detail',
      component: Detail
    },
    {
      path: '/marketplace',
      name: 'Marketplace',
      component: Marketplace
    },
    {
      path: '/blog',
      name: 'Blog',
      component: Blog
    },
    {
      path: '/',
      name: 'About',
      component: About
    },
    {
      path: '/blog/:slug',
      name: 'BlogDetail',
      component: BlogDetail
    },
    {
      path: '/contactanos',
      name: 'Contact',
      component: Contact
    }
  ]
})

// Global Guard navigation
router.beforeEach((to, from, next) => {
  console.log("es valida dla sesion",router.app.$session.exists())
  if (to.path.includes('home') || to.path.includes('marketplace') || to.path.includes('property-detail')) {
    if (!isAuthenticated(router.app.$session.exists())) {
      window.$cookies.remove('session')
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (to.path === '/') {
    if (router.app.$session.exists()) {
      next({
        path: '/home'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
